/**
 * Product category enum
 */
export enum ProductCategory {
  BIKE = 'bike',
  ACCESSORY = 'accessory',
  PART = 'part',
  CLOTHING = 'clothing',
  SAFETY = 'safety',
}

/**
 * Product interface matching Firestore schema
 */
export interface Product {
  id: string;
  name: string;
  description: string;
  category: ProductCategory;
  price: number; // in cents
  compareAtPrice?: number; // in cents (for showing discounts)
  sku?: string;
  stock: number;
  inStock: boolean;
  imageUrls: string[];
  specifications?: {
    [key: string]: string | number;
  };
  tags?: string[];
  isFeatured?: boolean;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

/**
 * Product filter options
 */
export interface ProductFilters {
  category?: ProductCategory;
  inStock?: boolean;
  minPrice?: number;
  maxPrice?: number;
  searchQuery?: string;
}

